import { IconButton, Snackbar } from '@mui/material'
import React from 'react'
import { useAppDispatch, useAppSelector } from '../hooks/reduxHooks'
import { closeSnackbar } from '../store/slice/appSlice'
import CloseIcon from '@mui/icons-material/Close'

const CommonSnackbar = () => {
	const { isShow, message } = useAppSelector(
		(state) => state.app.commonSnackbar,
	)
	const dispatch = useAppDispatch()

	return (
		<Snackbar
			open={isShow}
			autoHideDuration={6000}
			onClose={() => dispatch(closeSnackbar())}
			message={message}
			action={
				<IconButton
					aria-label="close"
					color="inherit"
					sx={{ p: 0.5 }}
					onClick={() => dispatch(closeSnackbar())}
				>
					<CloseIcon />
				</IconButton>
			}
		/>
	)
}

export default CommonSnackbar
